import React, { Component } from 'react'
import image from '../../mouseimages/init.jpg'
import '../stylesheets/introduction.css'
export default class Introduction extends Component {
    render() {
        return (
            <div className="intro-container">
               <section className="image-container">
                   <img src={image} alt="intro-img"></img>
               </section> 
               <section className="intro-content-container">
                  <h3>Special Features</h3>
                  <li>Control your mouse with voice commands</li>
                  <li>AI Control RGB based on your operation</li>
                  <li>Pointer suggest your next operation</li>

               </section>
            </div>
        )
    }
}
